// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab667f89","553":"39d4805c","977":"e85fbb29"}[chunkId] + ".chunk.js";
};